import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PriceDetailsService } from '@shared/components/price-details/price-details.service';
import { DynamicFormService } from '../../../routes/dev-tools/dynamic-form/dynamic-form.service';
import { DynamicFormValueService } from '@shared/components/dynamic-form-value/dynamic-form-value.service';
import { CommonsService } from '@core/service/commons.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-price-details',
  templateUrl: './price-details.component.html',
  styles: [],
})
export class PriceDetailsComponent implements OnInit {
  configData: any = {};
  singleLineTables = [];
  multipleLineTables = [];
  valueData: any = { data: {} };
  /**
   * 是否编辑
   */
  @Input() isEdit: boolean;

  /**
   * 打开
   */
  @Input() open: any;

  /**
   *动态表单代码（指明表单类型）
   */
  @Input() dynamicFormCode: string;
  /**
   * 业务对象那类型
   */
  @Input() bizType: string;
  /**
   * 业务对象Id
   */
  @Input() bizId: string;

  @ViewChild('dynamicForm') dynamicForm: NgForm;
  //当改变业务对象时父组件刷新
  @Output() private childOuter = new EventEmitter();

  //是否可切换编辑状态
  @Input() isSwitchState;

  constructor(
    private priceDetailsService: PriceDetailsService,
    private dynamicFormService: DynamicFormService, private dynamicFormValueService: DynamicFormValueService, private commonsService: CommonsService,
  ) {
  }


  ngOnInit() {
    this.dynamicFormService.getByCode(this.dynamicFormCode).subscribe(configData => {
      this.configData = configData;
      this.singleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Single');
      this.singleLineTables.forEach(v => {
        v.dynamicFieldGroups.forEach(j => {
          j.expand = true;
        });
      });
      this.multipleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Multiple');
      if (this.multipleLineTables.length) {
        this.multipleLineTables.sort(this.compare('orderNumber'));
        this.tableObj = this.multipleLineTables[0];
        this.tableObjInit();
      }
      this.initData();
      this.dynamicFormValueService.getByCodeAndBizTypeAndBizId(this.dynamicFormCode, this.bizType, this.bizId).subscribe(valueData => {
        this.valueData = valueData;
        this.initData();
        this.compute(this.singleLineTables);
        this.computeMultiple();
      }, () => {
        this.valueData = {
          dynamicFormId: this.configData.id,
          bizType: this.bizType,
          bizId: this.bizId,
          data: {},
        };
        this.initData();
      });
    });
  }

  public validateForm(): boolean {
    for (let item in this.dynamicForm.controls) {
      this.dynamicForm.controls[item].markAsDirty();
      this.dynamicForm.controls[item].updateValueAndValidity();
    }
    if (this.dynamicForm.valid) {
      return true;
    }
    return false;
  }

  //  保存
  saveFields() {
    for (let item in this.dynamicForm.controls) {
      this.dynamicForm.controls[item].markAsDirty();
      this.dynamicForm.controls[item].updateValueAndValidity();
    }
    if (!this.dynamicForm.valid) {
      return;
    }
    this.dynamicFormValueService.update(this.valueData).subscribe(() => {
      this.commonsService.showSuccessMessage('commons.info.saveSucceed');
    });
    this.childOuter.emit(this.bizId);
    this.close();
  }

  initData(): any {
    this.configData.dynamicTables.forEach(table => {
      if (!this.valueData) {
        this.valueData = {
          dynamicFormId: this.configData.id,
          bizType: this.bizType,
          bizId: this.bizId,
          data: {},
        };
      }
      if (!this.valueData.data) {
        this.valueData.data = {};
      }


      if (!this.valueData.data[table.tableName]) {
        if (table.dataType == 'Single') {
          this.valueData.data[table.tableName] = {};
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              if (!this.valueData.data[table.tableName][field.fieldName]) {
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }

          });
        } else if (table.dataType == 'Multiple') {
          this.valueData.data[table.tableName] = [];
        }

      } else {
        if (table.dataType == 'Single') {
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              if (!this.valueData.data[table.tableName][field.fieldName]) {
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }
          });
        } else if (table.dataType == 'Multiple') {
          table.dynamicFields.forEach(field => {
            if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
              for (let i = 0; i < this.valueData.data[table.tableName].length; i++) {
                if (!this.valueData.data[table.tableName][i][field.fieldName]) {
                  this.valueData.data[table.tableName][i][field.fieldName] = {};
                }
              }
            }
          });
        }
      }
    });
  }



  //点击编辑按钮切换为编辑状态
  edit() {
    this.isEdit = true;
  }

  //点击查看按钮切换为查看状态
  public tabsetIndex = 0;

  view() {
    this.tabsetIndex = 0;
    this.ngOnInit();
    this.isEdit = false;
  }

  //数组排序
  compare(property) {
    return function(a, b) {
      let value1 = a[property];
      let value2 = b[property];
      return value1 - value2;
    };
  }

  tableObjInit() {
    this.tableObj.dynamicFields.forEach(field => {
      if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
        if (!this.editTableFields[field.fieldName]) {
          this.editTableFields[field.fieldName] = {};
        }
      }
    });
  }


//  表格
  allChecked = false;
  indeterminate = false;
  displayData = [];
  public selectDatas: any = [];

  currentPageDataChange($event: Array<{ name: string; age: number; address: string; checked: boolean; disabled: boolean; }>): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    this.selectDatas = this.displayData.filter(value => value.checked);
  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  public tableObj: any = {};

  selectTableObj(tableItem) {
    setTimeout(() => {
      this.tableObj = tableItem;
      this.tableObjInit();
    }, 0);
  }

//  弹框
  @ViewChild('tableForm') tableForm: NgForm;
  public modalIsVisible: any = false;
  public editTableFields: any = {};
  public editeIndex: any = -1;

  editTableField(fields?, i?) {
    this.modalIsVisible = true;
    if (fields) {
      this.editTableFields = JSON.parse(JSON.stringify(fields));
      this.editeIndex = i;
    } else {
      this.editTableFields = {};
      this.editeIndex = -1;
    }
    this.tableObjInit();
  }

  deleteTableField() {
    let arr = [];
    for (let i = 0; i < this.valueData.data[this.tableObj.tableName].length; i++) {
      if (!this.valueData.data[this.tableObj.tableName][i].checked) {
        arr.push(this.valueData.data[this.tableObj.tableName][i]);
      }
    }
    setTimeout(() => {
      this.valueData.data[this.tableObj.tableName] = arr;
      this.selectDatas = [];
    }, 0);
  }

  handleCancel() {
    this.modalIsVisible = false;
  }

  handleOk() {
    for (let item in this.tableForm.controls) {
      this.tableForm.controls[item].markAsDirty();
      this.tableForm.controls[item].updateValueAndValidity();
    }
    if (!this.tableForm.valid) {
      return;
    }
    this.modalIsVisible = false;
    if (this.editeIndex == -1) {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr.push(this.editTableFields);
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    } else {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr[this.editeIndex] = this.editTableFields;
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    }
  }

  //单行
  compute(data) {
    let talNum = 0;
    data.forEach(v => {
      v.dynamicFields.forEach(j => {
        let config = JSON.parse(j.config);
        if (config.formula != null && config.formula != '') {
          if(config.formula){
            for(let i= 0;i<v.dynamicFields.length;i++){
              if(config.formula.indexOf(v.dynamicFields[i].fieldName) != -1){
                if(!this.valueData.data[v.tableName][v.dynamicFields[i].fieldName] && this.valueData.data[v.tableName][v.dynamicFields[i].fieldName]!=0){
                  return;
                }
              }
            }
          }
          let valueData = this.valueData.data[v.tableName];
          for (let value in valueData) {
            if (valueData[value] == null || valueData[value] == '' || valueData[value] == undefined) {
              valueData[value] = 0;
            }
            config.formula = config.formula.replace(value, valueData[value]);
            talNum = config.formula;
          }
          this.valueData.data[v.tableName][j.fieldName] = eval(String(talNum));
        }
      });
    });
  }

  //多行
  computeMultiple() {
    let talNum = null;
    this.multipleLineTables.forEach(v => {
      v.dynamicFields.forEach(j => {
        let config = JSON.parse(j.config);
        if(config.formula){
          for(let i= 0;i<v.dynamicFields.length;i++){
              if(config.formula.indexOf(v.dynamicFields[i].fieldName) != -1){
                  if(!this.editTableFields[v.dynamicFields[i].fieldName] && this.editTableFields[v.dynamicFields[i].fieldName]!=0){
                    return;
                  }
              }
          }
        }
        if (config.formula != null && config.formula != '') {
          let editTable = this.editTableFields;
          for (let value in editTable) {
            if (editTable[value] == null || editTable[value] == '' || editTable[value] == undefined) {
              editTable[value] = 0;
            }
            config.formula = config.formula.replace(value, editTable[value]);
            talNum = config.formula;
          }
          this.editTableFields[j.fieldName] = eval(talNum);
        }
      });
    });
  }

  close(){
    this.childOuter.emit(null);
    this.open.open = false;
  }

}
